module.exports = __webpack_public_path__ + "static/media/customer-care.8f09aa2d.svg";